import { selectStandardProps } from "@/utils/componentUtils";
import { Form, Select } from "antd";
import { FormItemProps } from "antd/lib/form";
import { SelectProps } from "antd/lib/select";
import { AcademicDegrees } from "../../../../common/constants";

interface Props {
  formItemProps: FormItemProps;
  selectProps?: SelectProps<string>;
}

const AcademicDegreeSelect = ({ formItemProps, selectProps }: Props) => (
  <Form.Item {...formItemProps}>
    <Select
      {...selectStandardProps}
      {...selectProps}
      options={AcademicDegrees.map((degree) => ({ value: degree, label: degree }))}
    />
  </Form.Item>
);

export default AcademicDegreeSelect;
